<template>
    <div class="bet-voice">
        <audio ref="msg" id="bgm" hidden :src="require('@/assets/music/msg.mp3')"></audio>
    </div>
</template>

<script>
export default {
    mounted(){
        this.$BUS.$on("bet", () => {
            let isplayer = sessionStorage.getItem("isplayer")
            if(isplayer == '1'){
                this.play()
            }
        })
    },
    methods: {
        play(){
            this.$refs.msg.play()
        }
    }
}
</script>

<style lang="scss" scoped>
.bet-voice {
    display: none;
}
</style>